module.exports = __webpack_public_path__ + "img/vife.cdc83ac7.png";